import { useCollapse } from 'react-collapsed';
import styles from './CollapsedFilesErrors.module.scss';
import { CaretDown, CaretUp, Warning } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { useContext, useMemo } from 'react';
import cn from 'classnames';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { v4 as uuidv4 } from 'uuid';

export const CollapsedFilesErrors = () => {
  const { threadInputBoxFiles } = useContext(ThreadInputBoxContext);
  const numberOfFiles = useMemo(() => {
    return threadInputBoxFiles ? Object.values(threadInputBoxFiles).length : 0;
  }, [threadInputBoxFiles]);

  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    defaultExpanded: false,
  });

  const numberOfFilesWithLoading = useMemo(() => {
    if (threadInputBoxFiles) {
      return Object.values(threadInputBoxFiles).filter(
        (file) => file?.isLoading,
      ).length;
    }
    return Object.values(threadInputBoxFiles || {}).length;
  }, [threadInputBoxFiles]);

  const filesWithErrors = useMemo(() => {
    return Object.values(threadInputBoxFiles || {}).filter(
      (file) => !!file?.errorMessage,
    );
  }, [threadInputBoxFiles]);

  const title =
    numberOfFilesWithLoading > 0
      ? `Processing ${numberOfFilesWithLoading} of ${numberOfFiles} attachment(s)...`
      : `Processed ${numberOfFiles} attachment(s).`;

  return (
    <div className={styles.root}>
      <div className={cn(styles.header, { [styles.expanded]: isExpanded })}>
        <button {...getToggleProps()} className={styles.collapseButton}>
          <div className={styles.titleWrapper}>
            <div>
              <span>{title}</span>
              {numberOfFilesWithLoading === 0 && (
                <span className={styles.errorText}>
                  {' '}
                  Please remove error files.
                </span>
              )}
            </div>
            <span className={styles.errorsCountWrapper}>
              <Warning size={SVG_SIZE_M} weight="fill" />{' '}
              {filesWithErrors.length}
            </span>
          </div>

          {isExpanded ? (
            <CaretUp size={SVG_SIZE_M} />
          ) : (
            <CaretDown size={SVG_SIZE_M} />
          )}
        </button>
      </div>
      <div className={styles.contentWrapper}>
        <div {...getCollapseProps()} className={styles.collapseWrapper}>
          <div className={styles.collapseItemsBlock}>
            <ul className={styles.errorsList}>
              {filesWithErrors.map((file, index) => (
                <li key={`file_attachment_${uuidv4()}`}>
                  {file?.file?.name}: {file?.errorMessage}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
